<template>
  <v-row align="center" justify="center" class="mt-6 pa-2">
    <v-card max-width="100%" width="500" flat color="background">
      <v-row align="center" justify="center">
        <v-carousel cycle height="450" hide-delimiter-background show-arrows-on-hover>
          <v-carousel-item v-for="(rating, i) in ratings" :key="i">
            <v-sheet light color="background" height="120%">
              <v-row align="center" justify="center">
                  <img src="../assets/usuario.svg" width="100" />
              </v-row>
              <v-row align="center" justify="center">
                <v-rating v-model="rating.puntuacion" color="primary" dense readonly size="40"></v-rating>
              </v-row>
              <v-row align="center" justify="center">
                <v-col cols="8">
                  <v-row align="center" justify="center">
                    <h3
                      class="text-center d-flex align-center justify-center textoRating"
                    >{{ '"' + rating.testimonio + '"'}}</h3>
                  </v-row>
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col cols="8">
                  <v-row align="center" justify="center">
                    <h3 class="text-center d-flex align-center justify-center">
                      <p class="textColor">
                        {{rating.usuario}} 
                        <b class="textBlack">{{rating.origen}}</b>
                      </p>
                    </h3>
                  </v-row>
                </v-col>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
import ratings from "../statics/ratingsLanding.json";

export default {
  data() {
    return {
      ratings,
    };
  },
};
</script>

<style scoped>
.textColor {
  font-size: 16px!important;
  font-weight: bold!important;
  font-stretch: normal!important;
  font-style: normal!important;
  line-height: normal!important;
  letter-spacing: -0.01px!important;
  text-align: center!important;
  color: #5932fd!important;
}

.textBlack {
  font-weight: normal!important;
  color: #303034!important;
  
}

.textoRating {
  width: 364px;
  height: 125px;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.02px;
  text-align: center;
  color: #303034;
}

</style>